export enum ValidatorResponseType {
  SUCCESS,
  ERROR,
  WARNING,
  NONE,
  EXTRA
}

export class ValidatorResponse {
  validatorType: ValidatorResponseType;
  message: string[];

  constructor(validatorType: ValidatorResponseType, message: string[]) {
    this.message = message;
    this.validatorType = validatorType;
  }

  isError() {
    return this.validatorType === ValidatorResponseType.ERROR;
  }

  isWarning() {
    return this.validatorType === ValidatorResponseType.WARNING;
  }

  isNone() {
    return this.validatorType === ValidatorResponseType.NONE;
  }

  isSuccess() {
    return this.validatorType === ValidatorResponseType.NONE;
  }
}
